/**
 * 讲义信息
 */
class Lecture {
  /**
   * 讲义ID
   */
  id = ''
  /**
   * 讲义类型，1代表html|2代表image|3表示vga
   */
  type: number
  /**
   * 播放时间点，单位：秒
   */
  timePoint: number
  /**
   * 讲义路径
   */
  path = ''
}

export default Lecture
